export default {
  localValidatorUrl: "https://kovan3.arbitrum.io/rpc",
  distributionAddress: "0xa2D931f1F1E18E6032f991DF34b05D431239e697",
  tokenAddress: "0x136407e33Ed5A790056477Efd41FDAb73d25395D",
  infuraId: process.env.INFURA_PROJECT_ID,
  infuraSecret: process.env.INFURA_PROJECT_SECRET,
};
